'use client';

import { Button } from '@/components/Button';
import { FormInput } from '@/components/FormInput';
import { useResetPasswordRequestEmail } from '@/hooks/useUserQuery';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslations } from 'next-intl';
import { useForm } from 'react-hook-form';
import { MoonLoader } from 'react-spinners';
import { z } from 'zod';

export const ResetPasswordRequestEMailForm = () => {
  const tForms = useTranslations('forms');
  const tResetPassword = useTranslations('reset-password');
  const tGeneral = useTranslations('general');

  const { mutate, isPending } = useResetPasswordRequestEmail();

  const FormValuesSchema = z.object({
    email: z
      .string()
      .email({ message: tForms('error-email') })
      .min(1, { message: tForms('error-email') })
      .max(255),
  });

  type FormValues = z.infer<typeof FormValuesSchema>;

  // React-Hook-Form.
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: zodResolver(FormValuesSchema),
  });

  // React-Hook-Form Submit.
  const onSubmit = handleSubmit((params) => mutate(params));

  return (
    <form className="space-y-6" onSubmit={onSubmit} noValidate>
      <FormInput
        {...register('email')}
        data-testid="reset-password-email"
        label={tForms('label-email')}
        type="email"
        errorMessage={errors.email?.message}
      />

      <div>
        <Button
          type="submit"
          disabled={isPending}
          data-testid="reset-password-request-submit"
          className="mt-10 flex w-full justify-center rounded-full bg-gray-900 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-gray-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 "
        >
          <MoonLoader
            size={19}
            color="#fff"
            loading={isPending}
            aria-label={tGeneral('label-loading-spinner')}
          />
          {!isPending && tResetPassword('label-submit')}
        </Button>
      </div>
    </form>
  );
};
